import { Tag } from '#/shared/ui/tag'
import type { TagProps } from '#/shared/ui/tag'

export interface IdCellBadge {
  label: string
  variant?: TagProps['variant']
}

interface IdCellProps {
  id: string
  badges?: IdCellBadge[]
}

export function IdCell({ id, badges }: IdCellProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center">
        <span className="text-sm text-primary group-hover:underline">{id}</span>
      </div>
      <div className="flex h-7 items-center gap-0.5">
        {badges?.map((badge, i) => (
          <Tag key={`${badge.label}-${i}`} variant={badge.variant}>
            {badge.label}
          </Tag>
        ))}
      </div>
    </div>
  )
}
